export default __webpack_public_path__ + "static/media/brainstar-echo.f2861d34.svg";